import AppBarAdmin from "../../components/AppBarAdmin";
import CustomDivider from "../../components/CustomDivider";
import Solicitacao from "../../components/Solicitacao";

export default function DetalhesGerenciamento() {
    return(
        <>
            <AppBarAdmin title="Detalhes" />
            <CustomDivider />
            <Solicitacao />
        </>
    )
}